import { DATE_GROUP } from '@constants/common';

export enum ChartCreationOptions {
  SqB = 'SqB',
  Auto_AI = 'Auto_AI',
  Self = 'Self'
}

export type ChartCreationMethod =
  | ChartCreationOptions.SqB
  | ChartCreationOptions.Self
  | ChartCreationOptions.Auto_AI
  | null;

export interface ChartConfigType {
  id: string;
  chart_title: string;
  chart_project: string;
  chart_short_desc: string;
  chart_long_desc: string;
  is_deleted: boolean;
  chart_reports?: null[] | null;
  has_edited_title: boolean;
  config: ChartConfig;
  colorset?: string[] | null;
  project_colorset?: string[] | null;
  svg_generated?: boolean;
  rating: number;
  method_used: ChartCreationMethod;
  chart_config_count: number;
}

export interface Range {
  endInd: number;
  startInd: number;
}
export interface DateRange {
  startingDate: string;
  endingDate: string;
}
export interface Filters {
  type: string;
  range: Range;
  xAxisLabelsExcluded: string[];
  dateRange?: DateRange | null;
}

export interface VisualSettings {
  filters?: Filters;
  sortOrder?: string;
  stackChart?: boolean;
  filtersToggle?: boolean;
  chartGlobalFilterToggle?: boolean;
  showDataLabels?: boolean;
  showLegends?: boolean;
  showEmptyValues?: boolean;
  showAsPercentage?: boolean;
  autoGroupNumbers?: boolean;
  '3d_charts'?: boolean;
  gradient_charts?: boolean;
  multicolor_charts?: boolean;
  theme_connection_status?: {
    '3d_charts': boolean;
    gradient_charts: boolean;
    multicolor_charts: boolean;
    colorThemeToggle?: boolean;
  };
  colorThemeToggle?: boolean;
  size?: { w: number; h: number };
  topOrBottomToggle?: boolean;
  kpiTarget?: number | null;
  toggleDashboardFilter?: boolean;
}
export interface ChartConfig {
  date_group: DATE_GROUP | 'none' | '';
  chart_type: string;
  chart_operation: string;
  chart_config: any;
  is_auto_generated?: boolean;
  is_active?: boolean;
  is_stacked?: boolean;
  visual_settings?: VisualSettings;
  filters?: any;
  dynamic_filters?: any;
  created_at?: string;
  x_axis?: XAxisOrYAxis;
  y_axis?: XAxisOrYAxis;
  segment_field: any | null;
  default_date_group: string;
  date_range: any;
}

export interface XAxisOrYAxis {
  id: string;
  fieldname: string;
  file_fieldname: string;
  detected_type: string;
  treat_as_type: string;
  to_import: boolean;
  contains_sensitive: boolean;
  sensitive_data_handling?: null;
  segment_list?: null;
  base_currency?: null;
  connected_currency_field?: null;
  is_segmentable: boolean;
  field_fav: boolean;
  data_facts: string;
  date_formats_found?: null;
  clean_percentage: string;
  empty_rows: number;
  unique_values: number;
  file_field_type_counts: string;
  is_us_date_format: boolean;
  created_at: string;
  updated_at: string;
  datafile: string;
  created_by: number;
  updated_by: number;
}

export interface ChartDetails {
  chart_title: string;
  chart_short_desc: string;
  chart_long_desc: string;
}

export interface ChartComment {
  author_text: string;
  by_self: boolean;
  comment: string;
  created_at: string;
  id: string;
  is_reply_to_obj_id: null;
  reply_to_author: null;
  reply_to_comment: null;
  updated_at: string;
}

export interface AvailableSettings {
  stacked?: {
    default_value: boolean;
  };
  show_legend?: {
    default_value: boolean;
  };
  sort_order?: {
    default_value: string;
  };
  show_empty_values?: {
    default_value: string;
  };
  date_interval?: {
    auto_applied: boolean;
  };
  number_grouping?: {
    auto_applied: boolean;
  };
}

export enum ChartSettings {
  STACKED = 'stacked',
  SHOW_LEGEND = 'show_legend',
  SORT_ORDER = 'sort_order',
  SHOW_EMPTY_VALUES = 'show_empty_values',
  DATE_INTERVAL = 'date_interval',
  NUMBER_GROUPING = 'number_grouping'
}
